<template lang="pug">
  .close-ctrl-bar
    span.icon.del(v-if='del', @click.stop='handleDel')
      i.iconfont.icon-trash
    span.icon.close(v-if='close', @click.stop='handleClose')
      i.iconfont.icon-close-outline
</template>
<script>
export default {
  name: 'closeCtrl',
  props: {
    close: {
      type: Boolean,
      default: true,
    },
    del: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleDel() {
      this.$vgo.open(() => {
        this.$emit('on-delete')
      })
    },
    handleClose() {
      this.$emit('on-close')
    },
  },
}
</script>
<style lang="stylus" scoped>
@import '~assets/styles/colors.styl'
@import '~assets/styles/variables.styl'
.close-ctrl-bar
  position: absolute
  right: 0
  top: 0
  z-index: $--zindex-high
  cursor: pointer
  .icon
    &:hover
      i
        color: $--color-danger
    i
      color: $--color-gray-dark
      font-size: 24px
  .del
    i
      font-size: 22px

.say
  .close-ctrl-bar
    right: 10px
    padding: 10px
    i
      font-size: 30px

.login-app
  .close-ctrl-bar
    padding: 10px
    i
      color: $--color-white
.login-pc
  .close-ctrl-bar
    padding: 10px
    i
      font-size: 30px
</style>
